import { render, staticRenderFns } from "./BodyTypeDialog.vue?vue&type=template&id=3386e60a&"
import script from "./BodyTypeDialog.vue?vue&type=script&lang=js&"
export * from "./BodyTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./BodyTypeDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BodyTypeDialog.vue"
export default component.exports